import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import Paginator from '../../common/Paginator';
import config from '../../../Config';

// FORMATTED MESSAGES
import IncomingReportsFormattedMessages from '../../../messages/reports/IncomingReportsFormattedMessages';

const ListComponent = ({ list }) => {
  const [pageLength, setPageLength] = useState(config.defaultPL);
  const [pageNumber, setPageNumber] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [count, setCount] = useState(0);

  const changePageLength = (e) => {
    const value = e.target.value;
    setPageLength(value);
    setPageNumber(1);
    changeEvent(1);
  };

  const changeEvent = (i) => {
    setPageNumber(i);
  };

  const handleList = () => {
    if (list && Array.isArray(list)) {
      const displayList = list.slice(
        (pageNumber - 1) * pageLength,
        (pageNumber - 1) * pageLength + pageLength
      );
      setDisplayList(displayList);
      setCount(list.length);
    } else {
      setCount(0);
      setDisplayList([]);
    }
  };

  useEffect(() => {
    handleList();
  }, [pageLength, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
    handleList();
  }, [list]);

  return (
    <>
      <TableContainer
        sx={{
          marginBottom: 4,
          overflowX: 'auto',
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{IncomingReportsFormattedMessages.deviceId}</TableCell>
              <TableCell>
                {IncomingReportsFormattedMessages.deviceName}
              </TableCell>
              <TableCell>
                {IncomingReportsFormattedMessages.deviceType}
              </TableCell>
              <TableCell>{IncomingReportsFormattedMessages.replyTn}</TableCell>
              <TableCell>{IncomingReportsFormattedMessages.outTotal}</TableCell>
              <TableCell>{IncomingReportsFormattedMessages.inTotal}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{displayList}</TableBody>
        </Table>
      </TableContainer>
      <Paginator
        itemCount={count}
        changeEvent={changeEvent}
        pageNumber={pageNumber}
        pageLength={pageLength}
        editFunction={changePageLength}
      />
    </>
  );
};

export default ListComponent;
